import routesCalibration from "../pages/calibrations/utils/routes";
import routesReport from "../pages/report/utils/routes";
import routesUncertainty from "../pages/uncertainty/utils/routes";
import routesUsers from "../pages/users/utils/routes";
import routerBackground from "../pages/background/utils/routes";
import routesTransit from "@app/pages/transitDose/utils/routes";
import routesMasterTables from "@app/pages/masterTables/utils/routes";
import routesDebug from "@app/pages/debug/utils/routes";

const adminRoutes = [
  routesUsers,
  routesUncertainty,
  routesCalibration,
  routesReport,
  routerBackground,
  routesTransit,
  routesMasterTables,
  routesDebug,
];

export default adminRoutes;
